import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyTopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#DC2626] text-white py-2 px-4 shadow-lg" data-id="element-178">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-179">
        <span className="font-bold text-sm sm:text-base uppercase tracking-wide flex items-center gap-2" data-id="element-180">
          <span className="animate-pulse" data-id="element-181">⚡</span> Esta oferta termina pronto
        </span>
        <div className="bg-white/20 px-3 py-1 rounded-md" data-id="element-182">
          <CountdownTimer size="sm" className="text-white drop-shadow-none" data-id="element-183" />
        </div>
      </div>
    </div>;
}